import { render, staticRenderFns } from "./AfterSignUp.vue?vue&type=template&id=310c1762&scoped=true&"
import script from "./AfterSignUp.vue?vue&type=script&lang=js&"
export * from "./AfterSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310c1762",
  null
  
)

export default component.exports